import { useEffect, useState } from 'react';
import { CustomTextField } from '../../../../components/CustomTextField';
import DivContainerBody from '../../../../components/DivContainerBody';
import CustomModal from '../../../../components/Modal/CustomModal';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const CancelReservationModal = ({ title, show, onHide, onConfirm, t }) => {
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (!show) setDescription('');
    }, [show]);

    return (
        <CustomModal
            title={title}
            show={show}
            onHide={onHide}
            onConfirm={() => onConfirm(description)} 
            buttonConfirm='confirm'
            size='md'
            classNameBody='m-0 p-0'
        >
            <DivContainerBody>
                <div className='d-flex flex-column justify-content-center gap-2 align-items-center'>
                    <p className='ibl-ientry-p ibl-font-w-400'>
                        {t('are_you_sure_to_proceed')}
                    </p>
                    <p className='ibl-ientry-p ibl-font-w-600 text-uppercase'>
                        {t('please_provide_a_reason')}
                    </p>
                </div>

                <div className='mt-3'>
                    <CustomTextField
                        length={512}
                        id='txt_cancel_reason'
                        name='description'
                        value={description}
                        trans='description'
                        required={true}
                        onChange={(e) => setDescription(e.target.value)}
                        multiline={true}
                        row={4}
                        placeholder={t('cancelation_reason')}
                    />
                </div>
            </DivContainerBody>
        </CustomModal>
    );
};

export default CancelReservationModal;
